import { render, staticRenderFns } from "./HomeServices.vue?vue&type=template&id=653baa68&scoped=true&"
import script from "./HomeServices.vue?vue&type=script&lang=js&"
export * from "./HomeServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653baa68",
  null
  
)

export default component.exports